export const confirmationPaneName = 'confirmationPane';
